import { render, staticRenderFns } from "./BookingSetting.vue?vue&type=template&id=6323568e&scoped=true"
import script from "./BookingSetting.vue?vue&type=script&lang=ts"
export * from "./BookingSetting.vue?vue&type=script&lang=ts"
import style0 from "./BookingSetting.vue?vue&type=style&index=0&id=6323568e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6323568e",
  null
  
)

export default component.exports